export interface CurrencyConfig {
  code: string;
  symbol: string;
  decimals: number;
  thousandsSeparator: string;
  decimalSeparator: string;
  symbolPosition: 'before' | 'after';
  displayName: string;
}

export const CURRENCIES: Record<string, CurrencyConfig> = {
  EUR: { 
    code: 'EUR', 
    symbol: '€', 
    decimals: 2, 
    thousandsSeparator: ',', 
    decimalSeparator: '.', 
    symbolPosition: 'before',
    displayName: 'EUR (€)'
  },
  USD: { 
    code: 'USD', 
    symbol: '$', 
    decimals: 2, 
    thousandsSeparator: ',', 
    decimalSeparator: '.', 
    symbolPosition: 'before',
    displayName: 'USD ($)'
  },
  GBP: { 
    code: 'GBP', 
    symbol: '£', 
    decimals: 2, 
    thousandsSeparator: ',', 
    decimalSeparator: '.', 
    symbolPosition: 'before',
    displayName: 'GBP (£)'
  },
  CAD: { 
    code: 'CAD', 
    symbol: 'C$', 
    decimals: 2, 
    thousandsSeparator: ',', 
    decimalSeparator: '.', 
    symbolPosition: 'before',
    displayName: 'CAD (C$)'
  },
  GEN: {
    code: 'GEN',
    symbol: '¤',
    decimals: 2,
    thousandsSeparator: ',',
    decimalSeparator: '.',
    symbolPosition: 'before',
    displayName: 'Generic (¤)'
  }
}; 